import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        if (!user.email || !user.password) {
            setError("Email and password are required.");
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(user.email)) {
            setError("Please enter a valid email address.");
            return false;
        }
        return true;
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setError("");
        setMessage("");
        setLoading(true);

        try {
            const sendData = { email: user.email, password: user.password };
            const result = await axios.post("https://skcapi.btcjapan.co/login.php", sendData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log("API Response:", result.data);

            if (result.data.Status === "200") {
                // Store user information in localStorage
                window.localStorage.setItem("token", result.data.token);
                window.localStorage.setItem("email", result.data.email);
                window.localStorage.setItem("userName", `${result.data.fname} ${result.data.lname}`);
                window.localStorage.setItem("usertype", result.data.usertype);
                window.localStorage.setItem("fname", result.data.fname);
                window.localStorage.setItem("lname", result.data.lname);
                window.localStorage.setItem("userId", result.data.id);

                setMessage("Login successful! Redirecting...");
                setTimeout(() => {
                    // Redirect all users to /admin-panel
                    navigate("/admin-panel");
                }, 1500);
            } else {
                setError(result.data.Message || "Login failed.");
            }
        } catch (err) {
            console.error("Login error:", err.response ? err.response.data : err.message);
            setError(err.response?.data?.Message || "An error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <h2 className="login-title">Login to SKC Japan</h2>
                <p className="login-subtitle">Access your account to explore our services</p>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                <form className="login-form" onSubmit={submitForm}>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={user.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            className="form-input"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={user.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            className="form-input"
                            required
                        />
                    </div>
                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? "Signing In..." : "Sign In"}
                    </button>
                </form>
                <p className="signup-link">
                    Don't have an account? <NavLink to="/sign-up" className="nav-link">Sign up here</NavLink>
                </p>
            </div>
        </div>
    );
};

export default Login;